import { render, staticRenderFns } from "./search-form.vue?vue&type=template&id=83d22306&lang=pug"
import script from "./search-form.vue?vue&type=script&lang=coffee"
export * from "./search-form.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports